// components/common/ToggleSwitch.jsx
import React from "react";

/**
 * Plain toggle switch (no text inside the track).
 *
 * @param {string}   id        - unique id for the checkbox input
 * @param {boolean}  checked   - current checked state
 * @param {Function} onChange  - (checked: boolean) => void
 * @param {boolean}  disabled  - disables the toggle
 */
const ToggleSwitch = ({ id, checked, onChange, disabled = false }) => (
  <div className="toggle-switch-wrapper">
    <label className={`toggle-switch ${disabled ? "is-disabled" : ""}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="toggle-switch__slider" />
    </label>
  </div>
);

export default ToggleSwitch;